module.exports = __webpack_public_path__ + "img/icon-bancolombia.cdedceb7.svg";